import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"check\">\n  <path d=\"M4.84,13.53.16,8.85a.53.53,0,0,1,0-.76h0a.53.53,0,0,1,.76,0l4.28,4.28,9.9-9.9a.53.53,0,0,1,.76,0h0a.53.53,0,0,1,0,.76L5.54,13.53A.5.5,0,0,1,4.84,13.53Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol